import { Component, OnDestroy, OnInit } from '@angular/core';
import { CustomerService } from '../_services/customer.service'
import { DataService } from '../_helpers/dataservice.service'
import { ParameterData } from '../_helpers/parameter.data';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Subject, throwError } from 'rxjs';

import { Router, ActivatedRoute } from '@angular/router';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DashboardService } from '../_services/dashboard.service'
import { AuthService } from '../_services/auth.service';

import { graphYear, graphDataBy } from '../_enums/dashboard-variables';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ApplicationService } from '../_services/application.service';
import { MetabaseService } from '../_services/metabase.service';
import { CustomDesignOptions } from '../sharedcomp/constans/customDesign.constans';
import { ConfigurationService } from '../_services';
import { Dashboard, DesignConfiguration } from '../_models/design-configuration.interface';
import { finalize, takeUntil } from 'rxjs/operators';
import { ApplicationTypes } from '../sharedcomp/constans/application-type.constans';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit, OnDestroy {
    form: FormGroup;

    private eventsSubject: Subject<void> = new Subject<void>();
    private eventsInvSubject: Subject<void> = new Subject<void>();

    public screenHeight: number;

    public customer_public_id: string;
    public customer_account_id: string;

    isLoading = false;
    dataDashboard :any=[];

    accessTokenObj: any;
    isLoggedin: any;

    jwtTokenObj: any;
    customerPuplic_key: any;


    customerAccountList: any;

    data: any;
    dataPayment: any;
    temp: any;
    graphDataJson: any;

    dashboardSummaryData: any;
    graphStatData: any;
    graphInvoicesData: any;
    graphPaymentsData: any;
    labelsArray = [];
    labelsArrayPayment = [];

    invoiceTotalSeriesArray = [];
    invoiceCountSeriesArray = [];
    paymentTotalSeriesArray = [];
    paymentCountSeriesArray = [];

    ddlGraphDataBy: any[];
    ddlGraphYear: any[];

    ddlNgGraphDataBy: any;
    ddlNgGraphDataYear: any;
    ddlNgGraphAccSelector: any;


    invoiceCountTotal: any;

    invoiceTotalSum: number;
    invoiceCountSum: number;

    paymentTotalSum: number;
    paymentCountSum: number;

    invoicePendingTotal: number;
    invoicePendingNumber: number;
    invoiceCurrentTotal: number;
    invoiceCurrentNumber: number;
    invoiceOverdueTotal: number;
    invoiceOverdueNumber: number;

    userAccountLength: any;
    isVisibleAccSelector: any;
    customerAccountList_curtmp: any;

    currentYear: any;
    currentSeries: any;
    currencySymbol: any;

    isGraphDataExist: any;
    isCustAccIdExist: any;
    isGraphApiReached = false;
    isSelectDisabled = false;
    invoices_pending: any;
    balance_account: any;
    invoices_rejected: any;
    balance_account_number: any;
    invoices_rejected_number: any;
    invoices_pending_number: any;
    currencySymbolDashboard: any;
    checkAT: any;
    configDashboard: boolean= false;
    penDefaultDashboard: any;
    public dashboardURL!: SafeResourceUrl;
    public isPaymentDashboardAvailable: boolean = false;
    public isotherDashboardAvailable: boolean = false;
    public dashboardOptions: Dashboard[];
    public isDashLoading: boolean = false;
    public dashboardForm = new FormGroup({
      dashboardSelectedForm: new FormControl('', [Validators.required]),
    });
    private destroy$ = new Subject<void>();

    constructor(
        private router: Router
        , private customerService: CustomerService
        , private dataService: DataService
        , private http: HttpClient
        , private parameterData: ParameterData
        , private datePipe: DatePipe
        , private spinnerService: Ng4LoadingSpinnerService
        , private dashboardService: DashboardService
        , private _graphDataBy: graphDataBy
        , private _graphYear: graphYear
        , private _authService: AuthService
        , private readonly activatedRoute: ActivatedRoute
        , private _applicationService: ApplicationService
        , private _metabaseService: MetabaseService
        , private _sanitizer: DomSanitizer
        , private _configurationService: ConfigurationService
    ) {
        this.dataService.currentPublicKey.subscribe(message => this.customerPuplic_key = message)

        this.isLoading = true;
        this.spinnerService.show();

        this.ddlGraphDataBy = _graphDataBy._graphData;
        this.ddlGraphYear = _graphYear._graphYr;

        this.invoicePendingTotal = 0;
        this.invoicePendingNumber = 0;
        this.invoiceCurrentTotal = 0;
        this.invoiceCurrentNumber = 0;
        this.invoiceOverdueTotal = 0;
        this.invoiceOverdueNumber = 0;

        const application = localStorage.getItem('application');
        const appType = this._applicationService.applicationType;
        if (!appType) {
          this._applicationService.setApplicationType(application);
        }
    }

     async ngOnInit() {
      const appType = this._applicationService.applicationType;
      this.form = new FormGroup({
            accountCurrency: new FormControl({ value: '', disabled: false })
          });
        this.currentYear = new Date();
        this.currentYear = this.currentYear.getFullYear();
        this.ddlNgGraphDataBy = 'total';
        this.currentSeries = 'total';
        this.ddlNgGraphDataYear = this.currentYear;
        localStorage.removeItem('isLoggedout');
        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
                return;
            }
            this.customer_public_id = localStorage.getItem('companyId');
            this.isGraphDataExist = sessionStorage.getItem("graphData");
            this.isCustAccIdExist = sessionStorage.getItem("accountid");
          } else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
          }

          if (appType === ApplicationTypes.PAYMENTS || appType === ApplicationTypes.CORPORATE || appType === ApplicationTypes.PAYOUTS) {
            await this.handlePaymentsFlow();
          } else {
            this.handleNonPaymentActions();
          }
        this.dataService.changeuserprofilephoto(localStorage.getItem('userPhoto'));
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

    public setDashboard(event: string): void {
      if (!event) {
        return;
      }
      const dashboard = this.dashboardOptions.find(t => t.id === event);
      const dashBoardType = dashboard.type;
      this.getMetabaseDashboard(event, dashBoardType);
    }

    async handlePaymentsFlow(): Promise<void> {
      try {
        const urlConfig = CustomDesignOptions.CUSTOMER;
        const data = await this._configurationService
          .getCustomDesignConfiguration<DesignConfiguration>(this.customer_public_id, urlConfig)
          .toPromise();
          this.dashboardOptions = data.values.dashboards;
          const dashboardID = data.values.dashboards[0].id;
          const dashBoardType = data.values.dashboards[0].type;
          this.dashboardForm.get('dashboardSelectedForm').setValue(dashboardID);

        if (dashboardID) {
          this.spinnerService.hide();
          this.isPaymentDashboardAvailable = true;
          await this.getMetabaseDashboard(dashboardID, dashBoardType);
        } else {
          this.handleNonPaymentActions();
        }
      } catch (error) {
        console.error('Error trying payments flow', error);
        this.handleNonPaymentActions();
      }
    }

    private handleNonPaymentActions(): void {
      this.isotherDashboardAvailable = true;
      this.getCustomerAccountList();
      this.checkDashboardAT();
    }

    public async getMetabaseDashboard(dashboardID: string, dashboardType: string): Promise<void> {
      try {
        this.isDashLoading = true;
        const data = await this._metabaseService.getMetabaseDashboard$(this.customer_public_id, dashboardID, dashboardType)
        .pipe(
          finalize(() => this.isDashLoading = false),
          takeUntil(this.destroy$)
        )
        .toPromise();
        this.dashboardURL = this._sanitizer.bypassSecurityTrustResourceUrl(data.data.url);
      } catch (error) {
        this.isDashLoading = false
        console.error('No metabase dashboard available', error);
      }
    }

    checkDashboardAT(){
        this.customerService.checkDashboardAT(this.customer_public_id).subscribe(data => {
        let dataDashboardAPi = data;
        this.checkAT = dataDashboardAPi;
        this.configDashboard = this.checkAT.values.payout_dashboard;
        this.penDefaultDashboard = this.checkAT.values.currency_default;
        this.form.get('accountCurrency').setValue(data.values.currency_default);
        this.currencySymbolDashboard = data.values.currency_default;
        this.getDetailsDashboard(data.values.currency_default);

        if(this.penDefaultDashboard==='PEN'){
            this.penDefaultDashboard= 'S/.';
        }
        else if(this.penDefaultDashboard==='USD'){
            this.penDefaultDashboard = 'US$';
        }
        })
    }

    getDetailsDashboard(currencySymbolDashboard){
        if (currencySymbolDashboard !== 'USD' && currencySymbolDashboard !== 'PEN') {
            if(currencySymbolDashboard==='S/.'){
                currencySymbolDashboard= 'PEN';
            }
            else if(currencySymbolDashboard==='US$'){
                currencySymbolDashboard = 'USD';
            }
            else{
                currencySymbolDashboard = "PEN";
        }
        }
        this.dashboardService.getDashboardGraphDetailsWidget(this.customer_public_id, currencySymbolDashboard).subscribe(data => {
            let dataApi = data
            this.dataDashboard = dataApi
            this.invoices_pending =this.dataDashboard.data.indicator_list[0].total
            this.invoices_pending_number =this.dataDashboard.data.indicator_list[0].number
            this.invoices_rejected =this.dataDashboard.data.indicator_list[1].total
            this.invoices_rejected_number =this.dataDashboard.data.indicator_list[1].number
            this.balance_account =this.dataDashboard.data.indicator_list[2].total
        })
    }

    /*
      * This function is used to get the customer account list from the service; *
     */
    getCustomerAccountList() {
        this.customerService.getCustomerAccountList(this.customer_public_id).subscribe(data => {
            let resourcesReturn = data;
            if (resourcesReturn != "") {
                this.customerAccountList = resourcesReturn;
                if(localStorage.getItem('application') == 'PAYOUTS') {
                    this.customerAccountList = this.customerAccountList.filter(t => t.type == 'PAYABLE');
                }else {
                    this.customerAccountList = this.customerAccountList.filter(t => t.type == 'RECEIVABLE' || t.type == 'COLLECT' || t.type == 'WALLET');
                }
                this.customer_account_id = this.customerAccountList[0].public_id;
                this.userAccountLength = this.customerAccountList.length;
                this.currencySymbol = this.customerAccountList[0].balance.symbol;

                sessionStorage.setItem("accountid", this.customer_account_id);

                if (this.userAccountLength >= 1 && this.userAccountLength != undefined && this.userAccountLength != 0) {
                    this.isVisibleAccSelector = true;

                    this.ddlNgGraphAccSelector = this.customerAccountList[0].name;

                    this.changeCurrencyValue(this.ddlNgGraphAccSelector);
                }
                else {
                    this.isVisibleAccSelector = false;

                }


                if ((this.isGraphDataExist == null || this.isGraphDataExist == undefined || this.isGraphDataExist == '') && (this.isCustAccIdExist == null || this.isCustAccIdExist == undefined || this.isCustAccIdExist == '')) {
                    if (this.isGraphApiReached == false) {
                        this.getGraphData("total", this.currentYear, this.customer_account_id);
                    }
                }
                else {
                    this.getGraphDataFromLocalStorage("total", this.currentYear, this.customer_account_id);
                }
            }
            else {
                return " ";
            }
        },
            error => {
                console.log('Failed while trying to the get Customer Account List Result. ' + error);
            });
    }//end


    changeCurrencyValue(currencyval: string) {

        this.customerAccountList_curtmp = this.customerAccountList.filter(t => t.name == currencyval);
        this.customer_account_id = this.customerAccountList_curtmp[0].public_id;
        this.currencySymbol = this.customerAccountList_curtmp[0].balance.symbol;
        this.getGraphData("total", this.currentYear, this.customer_account_id);
    }//end


    /*
      * This function is used to get the customer graph data from the service; *
     */
    async getGraphData(series: string, year: string, account_id: string) {
        //  setTimeout(() => {
        this.isSelectDisabled = true;
        if (account_id == "" || account_id == undefined || account_id == null) {
            account_id = this.customer_account_id;
        }

        this.ddlNgGraphDataBy = series;

        if ((year == '' || year == null || year == undefined)) {
            this.ddlNgGraphDataYear = this.currentYear;
            year = this.currentYear;
        }
        else {
            this.ddlNgGraphDataYear = year;
            this.currentYear = year;
        }

        if ((series == '' || series == null || series == undefined)) {
            this.ddlNgGraphDataBy = this.currentSeries;
            series = this.currentSeries;
        }
        else {
            this.ddlNgGraphDataBy = series;
            this.currentSeries = series;
        }

        this.isLoading = true;
        this.isGraphApiReached = true;
        try {
            const data = await this.dashboardService.getDashboardGraphDetails(this.customer_public_id, account_id, year)
            let resources = data["data"];
            this.graphDataJson = resources;



            sessionStorage.setItem("graphData", JSON.stringify(resources));

            sessionStorage.setItem("accountid", account_id);

            this.dashboardSummaryData = this.graphDataJson["0"].indicator_list;
            this.graphInvoicesData = this.graphDataJson["1"].indicator_list;
            this.graphPaymentsData = this.graphDataJson["2"].indicator_list;



            this.invoiceTotalSum = 0;
            this.invoiceCountSum = 0;
            this.paymentTotalSum = 0;
            this.paymentCountSum = 0;

            this.invoicePendingTotal = 0;
            this.invoicePendingNumber = 0;
            this.invoiceCurrentTotal = 0;
            this.invoiceCurrentNumber = 0;
            this.invoiceOverdueTotal = 0;
            this.invoiceOverdueNumber = 0;

            this.invoicePendingTotal = this.dashboardSummaryData["0"].total;
            this.invoicePendingNumber = this.dashboardSummaryData["0"].number;

            this.invoiceCurrentTotal = this.dashboardSummaryData["1"].total;
            this.invoiceCurrentNumber = this.dashboardSummaryData["1"].number;

            this.invoiceOverdueTotal = this.dashboardSummaryData["2"].total;
            this.invoiceOverdueNumber = this.dashboardSummaryData["2"].number;



            this.labelsArray = [];
            this.labelsArrayPayment = [];
            this.invoiceTotalSeriesArray = [];
            this.invoiceCountSeriesArray = [];
            this.paymentTotalSeriesArray = [];
            this.paymentCountSeriesArray = [];

            for (var i in this.graphInvoicesData) {

                this.temp = this.graphInvoicesData[i].year + '/' + this.graphInvoicesData[i].month + '/01';
                this.temp = Date.parse(this.temp);
                this.labelsArray.push(this.datePipe.transform(this.temp, 'MMM'));

                this.invoiceTotalSeriesArray.push(this.graphInvoicesData[i].total);
                this.invoiceCountSeriesArray.push(this.graphInvoicesData[i].number);

                this.invoiceTotalSum = this.invoiceTotalSum + Number(this.graphInvoicesData[i].total);
                this.invoiceCountSum = this.invoiceCountSum + Number(this.graphInvoicesData[i].number);

            }//end for

            for (var j in this.graphPaymentsData) {
                this.temp = this.graphPaymentsData[j].year + '/' + this.graphPaymentsData[j].month + '/01';
                this.temp = Date.parse(this.temp);

                this.labelsArrayPayment.push(this.datePipe.transform(this.temp, 'MMM'));

                this.paymentTotalSeriesArray.push(this.graphPaymentsData[j].total);
                this.paymentCountSeriesArray.push(this.graphPaymentsData[j].number);

                this.paymentTotalSum = this.paymentTotalSum + Number(this.graphPaymentsData[j].total);
                this.paymentCountSum = this.paymentCountSum + Number(this.graphPaymentsData[j].number);

            }//end for

            // //data assignment
            if (series === 'total') {
                this.data = {
                    labels: this.labelsArray,
                    series: [this.invoiceTotalSeriesArray]
                };
            }
            else {
                this.data = {
                    labels: this.labelsArray,
                    series: [this.invoiceCountSeriesArray]
                };
            }

            if (series === 'total') {
                this.dataPayment = {
                    labels: this.labelsArrayPayment,
                    series: [this.paymentTotalSeriesArray]
                };
            }
            else {
                this.dataPayment = {
                    labels: this.labelsArrayPayment,
                    series: [this.paymentCountSeriesArray]
                };
            }


            this.dataService.changechartdatainvoice(this.data);
            this.dataService.changechartdatapayment(this.dataPayment);

            this.eventsSubject.next();
            this.eventsInvSubject.next();

            this.isLoading = false;
            setTimeout(() => {
            this.spinnerService.hide();
            },1000)
        }
        catch (error) {
            console.log('Failed to get the graph data.' + error)
        }
            this.isSelectDisabled = false;

        // },
        //    error => {
        //         console.log('Failed to get the graph data. ' + error);
        //          this.isLoading = true;
        //   });


        // }, 3000);
        //set timeout end


    }//end




        changeCurrencyValueWidget(currencyval: string) {
            if (currencyval) {
                this.customerAccountList_curtmp = this.customerAccountList.filter(t => t.balance.currency == currencyval);
                this.customer_account_id = this.customerAccountList_curtmp[0].public_id;
                this.currencySymbol = this.customerAccountList_curtmp[0].balance.symbol;
                this.penDefaultDashboard= this.currencySymbol
                this.currencySymbolDashboard = this.currencySymbol
                this.getGraphDataWidget("total", this.currentYear, this.customer_account_id);
                this.getDetailsDashboard(this.penDefaultDashboard);
            }
        }//end

        async getGraphDataWidget(series: string, year: string, account_id: string) {

            try {
                const data = await this.dashboardService.getDashboardGraphDetails(this.customer_public_id, account_id, year)
                let resources = data["data"];
                this.graphDataJson = resources;

                sessionStorage.setItem("graphData", JSON.stringify(resources));

                sessionStorage.setItem("accountid", account_id);

                this.dashboardSummaryData = this.graphDataJson["0"].indicator_list;
                this.graphInvoicesData = this.graphDataJson["1"].indicator_list;
                this.graphPaymentsData = this.graphDataJson["2"].indicator_list;

                this.invoicePendingTotal = this.dashboardSummaryData["0"].total;
                this.invoicePendingNumber = this.dashboardSummaryData["0"].number;

                this.invoiceCurrentTotal = this.dashboardSummaryData["1"].total;
                this.invoiceCurrentNumber = this.dashboardSummaryData["1"].number;

                this.invoiceOverdueTotal = this.dashboardSummaryData["2"].total;
                this.invoiceOverdueNumber = this.dashboardSummaryData["2"].number;
            }
            catch(error) {
                console.log('Failed to get the graph data.' + error)
            }
        }

        changeCurrencyValueDashboard(currencyval: string) {

            this.customerAccountList_curtmp = this.customerAccountList.filter(t => t.name == currencyval);

            this.customer_account_id = this.customerAccountList_curtmp[0].public_id;
            this.getGraphDataDashboard("total", this.currentYear, this.customer_account_id);
        }//end

        async getGraphDataDashboard(series: string, year: string, account_id: string) {

            //  setTimeout(() => {
            this.isSelectDisabled = true;
            if (account_id == "" || account_id == undefined || account_id == null) {
                account_id = this.customer_account_id;
            }

            this.ddlNgGraphDataBy = series;

            if ((year == '' || year == null || year == undefined)) {
                this.ddlNgGraphDataYear = this.currentYear;
                year = this.currentYear;
            }
            else {
                this.ddlNgGraphDataYear = year;
                this.currentYear = year;
            }

            if ((series == '' || series == null || series == undefined)) {
                this.ddlNgGraphDataBy = this.currentSeries;
                series = this.currentSeries;
            }
            else {
                this.ddlNgGraphDataBy = series;
                this.currentSeries = series;
            }

            this.isLoading = true;
            this.isGraphApiReached = true;
            try {
                const data = await this.dashboardService.getDashboardGraphDetails(this.customer_public_id, account_id, year)
                let resources = data["data"];
                this.graphDataJson = resources;

                sessionStorage.setItem("graphData", JSON.stringify(resources));

                sessionStorage.setItem("accountid", account_id);

                // this.dashboardSummaryData = this.graphDataJson["0"].indicator_list;
                this.graphInvoicesData = this.graphDataJson["1"].indicator_list;
                this.graphPaymentsData = this.graphDataJson["2"].indicator_list;

                this.invoiceTotalSum = 0;
                this.invoiceCountSum = 0;
                this.paymentTotalSum = 0;
                this.paymentCountSum = 0;

                this.invoicePendingTotal = 0;
                this.invoicePendingNumber = 0;
                this.invoiceCurrentTotal = 0;
                this.invoiceCurrentNumber = 0;
                this.invoiceOverdueTotal = 0;
                this.invoiceOverdueNumber = 0;

                this.invoicePendingTotal = this.dashboardSummaryData["0"].total;
                this.invoicePendingNumber = this.dashboardSummaryData["0"].number;

                this.invoiceCurrentTotal = this.dashboardSummaryData["1"].total;
                this.invoiceCurrentNumber = this.dashboardSummaryData["1"].number;

                this.invoiceOverdueTotal = this.dashboardSummaryData["2"].total;
                this.invoiceOverdueNumber = this.dashboardSummaryData["2"].number;

                this.labelsArray = [];
                this.labelsArrayPayment = [];
                this.invoiceTotalSeriesArray = [];
                this.invoiceCountSeriesArray = [];
                this.paymentTotalSeriesArray = [];
                this.paymentCountSeriesArray = [];

                for (var i in this.graphInvoicesData) {

                    this.temp = this.graphInvoicesData[i].year + '/' + this.graphInvoicesData[i].month + '/01';
                    this.temp = Date.parse(this.temp);
                    this.labelsArray.push(this.datePipe.transform(this.temp, 'MMM'));

                    this.invoiceTotalSeriesArray.push(this.graphInvoicesData[i].total);
                    this.invoiceCountSeriesArray.push(this.graphInvoicesData[i].number);

                    this.invoiceTotalSum = this.invoiceTotalSum + Number(this.graphInvoicesData[i].total);
                    this.invoiceCountSum = this.invoiceCountSum + Number(this.graphInvoicesData[i].number);

                }//end for

                for (var j in this.graphPaymentsData) {
                    this.temp = this.graphPaymentsData[j].year + '/' + this.graphPaymentsData[j].month + '/01';
                    this.temp = Date.parse(this.temp);

                    this.labelsArrayPayment.push(this.datePipe.transform(this.temp, 'MMM'));

                    this.paymentTotalSeriesArray.push(this.graphPaymentsData[j].total);
                    this.paymentCountSeriesArray.push(this.graphPaymentsData[j].number);

                    this.paymentTotalSum = this.paymentTotalSum + Number(this.graphPaymentsData[j].total);
                    this.paymentCountSum = this.paymentCountSum + Number(this.graphPaymentsData[j].number);

                }//end for

                // //data assignment
                if (series === 'total') {
                    this.data = {
                        labels: this.labelsArray,
                        series: [this.invoiceTotalSeriesArray]
                    };
                }
                else {
                    this.data = {
                        labels: this.labelsArray,
                        series: [this.invoiceCountSeriesArray]
                    };
                }

                if (series === 'total') {
                    this.dataPayment = {
                        labels: this.labelsArrayPayment,
                        series: [this.paymentTotalSeriesArray]
                    };
                }
                else {
                    this.dataPayment = {
                        labels: this.labelsArrayPayment,
                        series: [this.paymentCountSeriesArray]
                    };
                }

                this.dataService.changechartdatainvoice(this.data);
                this.dataService.changechartdatapayment(this.dataPayment);

                this.eventsSubject.next();
                this.eventsInvSubject.next();

                this.isLoading = false;
                setTimeout(() => {
                this.spinnerService.hide();
                },1000)
            }
            catch (error) {
                console.log('Failed to get the graph data.' + error)
            }
                this.isSelectDisabled = false;
        }//end







    getGraphDataFromLocalStorage(series: string, year: string, account_id: string) {
       // setTimeout(() => {


            if (account_id == "" || account_id == undefined || account_id == null) {
                account_id = this.customer_account_id;
            }

            this.ddlNgGraphDataBy = series;

            if ((year == '' || year == null || year == undefined)) {
                this.ddlNgGraphDataYear = this.currentYear;
                year = this.currentYear;
            }
            else {
                this.ddlNgGraphDataYear = year;
                this.currentYear = year;
            }

            if ((series == '' || series == null || series == undefined)) {
                this.ddlNgGraphDataBy = this.currentSeries;
                series = this.currentSeries;
            }
            else {
                this.ddlNgGraphDataBy = series;
                this.currentSeries = series;
            }




            this.isLoading = true;



            let resources = sessionStorage.getItem("graphData");
            this.graphDataJson = JSON.parse(resources);


            sessionStorage.setItem("graphData", resources);
            sessionStorage.setItem("accountid", account_id);

            this.dashboardSummaryData = this.graphDataJson["0"].indicator_list;
            this.graphInvoicesData = this.graphDataJson["1"].indicator_list;
            this.graphPaymentsData = this.graphDataJson["2"].indicator_list;


            this.invoiceTotalSum = 0;
            this.invoiceCountSum = 0;
            this.paymentTotalSum = 0;
            this.paymentCountSum = 0;

            this.invoicePendingTotal = 0;
            this.invoicePendingNumber = 0;
            this.invoiceCurrentTotal = 0;
            this.invoiceCurrentNumber = 0;
            this.invoiceOverdueTotal = 0;
            this.invoiceOverdueNumber = 0;

            this.invoicePendingTotal = this.dashboardSummaryData["0"].total;
            this.invoicePendingNumber = this.dashboardSummaryData["0"].number;

            this.invoiceCurrentTotal = this.dashboardSummaryData["1"].total;
            this.invoiceCurrentNumber = this.dashboardSummaryData["1"].number;

            this.invoiceOverdueTotal = this.dashboardSummaryData["2"].total;
            this.invoiceOverdueNumber = this.dashboardSummaryData["2"].number;

            this.labelsArray = [];
            this.labelsArrayPayment = [];
            this.invoiceTotalSeriesArray = [];
            this.invoiceCountSeriesArray = [];
            this.paymentTotalSeriesArray = [];
            this.paymentCountSeriesArray = [];

            for (var k in this.graphInvoicesData) {

                this.temp = this.graphInvoicesData[k].year + '/' + this.graphInvoicesData[k].month + '/01';
                this.temp = Date.parse(this.temp);
                this.labelsArray.push(this.datePipe.transform(this.temp, 'MMM'));

                this.invoiceTotalSeriesArray.push(this.graphInvoicesData[k].total);
                this.invoiceCountSeriesArray.push(this.graphInvoicesData[k].number);

                this.invoiceTotalSum = this.invoiceTotalSum + Number(this.graphInvoicesData[k].total);
                this.invoiceCountSum = this.invoiceCountSum + Number(this.graphInvoicesData[k].number);

            }//end for

            for (var l in this.graphPaymentsData) {
                this.temp = this.graphPaymentsData[l].year + '/' + this.graphPaymentsData[l].month + '/01';
                this.temp = Date.parse(this.temp);

                this.labelsArrayPayment.push(this.datePipe.transform(this.temp, 'MMM'));

                this.paymentTotalSeriesArray.push(this.graphPaymentsData[l].total);
                this.paymentCountSeriesArray.push(this.graphPaymentsData[l].number);

                this.paymentTotalSum = this.paymentTotalSum + Number(this.graphPaymentsData[l].total);
                this.paymentCountSum = this.paymentCountSum + Number(this.graphPaymentsData[l].number);

            }//end for

            // //data assignment
            if (series === 'total') {
                this.data = {
                    labels: this.labelsArray,
                    series: [this.invoiceTotalSeriesArray]
                };
            }
            else {
                this.data = {
                    labels: this.labelsArray,
                    series: [this.invoiceCountSeriesArray]
                };
            }

            if (series === 'total') {
                this.dataPayment = {
                    labels: this.labelsArrayPayment,
                    series: [this.paymentTotalSeriesArray]
                };
            }
            else {
                this.dataPayment = {
                    labels: this.labelsArrayPayment,
                    series: [this.paymentCountSeriesArray]
                };
            }


            this.dataService.changechartdatainvoice(this.data);
            this.dataService.changechartdatapayment(this.dataPayment);

            this.eventsSubject.next();
            this.eventsInvSubject.next();

            this.isLoading = false;

            setTimeout(() => {
                this.spinnerService.hide();
                },1000)

        //}, 1000);
        //set timeout end


    }//end

}//end


